import type { CartProductSchema } from '../../types';
import type { State } from '../types';
import { isFreeOffering } from './is-free-offering';

export function getTrialStatusForEntitlement({
  productId,
  currentOfferingId,
  updatedOfferingId,
  offeringsAndpricingPlans,
  inCurrentlyInTrial,
}: {
  productId: CartProductSchema['productId'];
  currentOfferingId: string;
  updatedOfferingId: string;
  offeringsAndpricingPlans: NonNullable<State['offeringsAndpricingPlans']>;
  inCurrentlyInTrial: boolean;
}) {
  const offerings = offeringsAndpricingPlans[productId];

  const currentOfferingDetails = offerings?.find?.(({ id: offeringId }) => offeringId === currentOfferingId);
  const updatedOfferingDetails = offerings?.find?.(({ id: offeringId }) => offeringId === updatedOfferingId);

  const isCurrentFree = isFreeOffering(currentOfferingDetails?.pricingType ?? '');
  const isUpdatedOfferingFree = isFreeOffering(updatedOfferingDetails?.pricingType ?? '');

  if (isCurrentFree) return true;
  if (isUpdatedOfferingFree) return false;

  const currentLevel = currentOfferingDetails?.level ?? 0;
  const updatedLevel = updatedOfferingDetails?.level ?? 0;

  if (updatedLevel === currentLevel) {
    // for same levels, always check the current state of trial
    return inCurrentlyInTrial;
  }

  // upgrade scenario or a special case where `Standard` and `Standard Free` had equal levels. this will go into trial
  if (updatedLevel > currentLevel) {
    return true;
  }

  // downgrade scenario.
  if (updatedLevel < currentLevel) {
    // if downgrading from a trial plan, the next plan will also be in trial
    if (inCurrentlyInTrial) return true;

    // when downgrading from a paid subscription, there will be no trial
    return false;
  }

  return false;
}
